<!--
  Mirrors CallHistoryList.vue's structure/skeleton/empty-state conventions
  exactly (same ch-list scaffolding, ch-row--skeleton shimmer, ch-empty
  markup) -- only the row component and column headers differ, since dial
  attempts don't have a "From number"/"Direction" pair the way connected
  calls do.
-->
<template>
  <section class="ch-list" aria-label="Dial attempts">
    <div class="ch-list__head">
      <div class="da-list__columns" aria-hidden="true">
        <span>When</span>
        <span>Caller</span>
        <span>Outcome</span>
        <span>Notes</span>
        <span>Duration</span>
        <span>Details</span>
      </div>
    </div>

    <div class="ch-list__scroll">
      <div v-if="loading" class="ch-list__body">
        <div v-for="n in 8" :key="n" class="ch-row ch-row--skeleton" />
      </div>

      <div v-else-if="attempts.length" class="ch-list__body" role="list">
        <DialAttemptRow
          v-for="attempt in attempts"
          :key="attempt.id"
          :call="attempt"
          @open-detail="$emit('open-detail', $event)"
        />
      </div>

      <div v-else class="ch-empty">
        <v-icon icon="mdi-phone-log-outline" size="40" class="ch-empty__icon" />

        <p class="ch-empty__title">No dial attempts yet</p>

        <p class="ch-empty__subtitle">
          Every dial this campaign makes -- connected or not -- will show up here.
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import DialAttemptRow from '@/components/CallHistory/DialAttemptRow.vue'

defineOptions({ name: 'DialAttemptsList' })

defineProps({
  attempts: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
})

defineEmits(['open-detail'])
</script>
